// extracted by mini-css-extract-plugin
export default {"root":"MenuManage_root__G2ulJ"};